import { createAtomObserver } from '@exodus/atoms'

const createFavoriteAssetsLifecyclePlugin = ({ favoriteAssetsAtom, port }) => {
  const favoriteAssetsAtomObserver = createAtomObserver({
    port,
    atom: favoriteAssetsAtom,
    event: 'favoriteAssets',
  })

  const onLoad = ({ isLocked }) => {
    if (isLocked) return

    favoriteAssetsAtomObserver.start()
  }

  const onUnlock = () => {
    favoriteAssetsAtomObserver.start()
  }

  const onStop = () => {
    favoriteAssetsAtomObserver.unregister()
  }

  return { onLoad, onUnlock, onStop }
}

export default createFavoriteAssetsLifecyclePlugin
